<template>
  <v-row>
    <v-col class="chat-auditorium">

      <v-row>
        <!-- Entrada de texto -->
        <v-text-field 
          class="message-input pl-2 pr-2"
          counter="200"
          maxlength="200"
          v-model="newMessage"
          label="Escribe tu mensaje"
          placeholder="Enter para enviar"
          @keyup.enter="sendMessage"
        ></v-text-field>
      </v-row>
    
      <v-row style="height: 380px;">
        <v-col cols="12">
          <v-sheet class="mt-8 overflow-auto" style="height: 330px;">
            <div v-for="message in messages" :key="message.id" class="pb-2">
              <small style="color: blue; font-weight: 500;">{{ message.user.name }} dice:</small>
              <h5 class="text--secondary">{{ message.message }}</h5>
            </div>
          </v-sheet>
        </v-col>
      </v-row>
    </v-col>

  </v-row>
</template>
<script>
import axios from 'axios'

export default {
  props:['edition_id', 'auditorium_slug', 'activity_slug'],

  data() {
    return {
      messages: [],
      newMessage: '', // Nuevo mensaje
      selectedItem: null, // Item seleccionado en la lista de mensajes
      intervalId: null
    }
  },
  methods: {
    async getMessages(){
      await axios.get('participant/auditoriums/'+this.edition_id+'/'+this.auditorium_slug+'/activity/'+this.activity_slug+'/messages').then(response =>{
        this.messages = response.data.data.messages

        this.loading = false
      }).catch(error => {
        this.loading = false
        console.log(error);
      })
    },
    
    async sendMessage() {
      if (this.newMessage.trim() !== '') {
        try {
          await axios.post('participant/auditoriums/'+this.edition_id+'/'+this.auditorium_slug+'/activity/'+this.activity_slug+'/messages',{
            message: this.newMessage
            }).then(response =>{
              this.newMessage = ''
              this.getMessages()
              console.log(response)
            })
        } catch (error) {
            this.message = ''
            this.dialog_message = false
            console.error(error.response.data);     // NOTE - use "error.response.data` (not "error")
        }
      }
    }
  },
  created(){
    this.getMessages()
    this.intervalId = setInterval(this.getMessages, 12000);
  },
  
  destroyed() {
    clearInterval(this.intervalId); // Limpia el intervalo cuando la vista se desmonta
  },
}
</script>


<style scoped>
.message-input {
  flex-grow: 1;
  margin-bottom: -30px!important;
}


.chat-auditorium {
  display: flex;
  flex-direction: column;
  max-height: max-content;
}

.message-sent {
  text-align: right;
}

.message-received {
  text-align: left;
}
</style>